import React from 'react';
import { Handle, Position } from '@xyflow/react';

interface VirtualNodeProps {
  data?: any;
}

export const VirtualNode: React.FC<VirtualNodeProps> = ({ data }) => {
  const layoutDirection = data?.layoutDirection || 'LR';
  const isTB = layoutDirection === 'TB';

  return (
    <div style={{ width: 1, height: '50px', background: 'transparent' }}>
      <Handle
        type="target"
        position={isTB ? Position.Top : Position.Left}
        id="left"
        style={isTB ? { opacity: 0, top: 0, left: '50%' } : { opacity: 0, left: 0, top: '50%' }}
      />
    </div>
  );
};
